"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaNavigationMenus = exports.TopAreaNavigationLinkToMenuTypesMapper = exports.TopAreaNavigationLink = void 0;
var _toggleMenuFlyout = require("@ori-events/toggle-menu-flyout");
let TopAreaNavigationLink = exports.TopAreaNavigationLink = /*#__PURE__*/function (TopAreaNavigationLink) {
  TopAreaNavigationLink["BeautyTipsMenu"] = "#menubeautytips";
  TopAreaNavigationLink["InspirationMenu"] = "#menuinspiration";
  return TopAreaNavigationLink;
}({});
const TopAreaNavigationLinkToMenuTypesMapper = exports.TopAreaNavigationLinkToMenuTypesMapper = {
  [TopAreaNavigationLink.BeautyTipsMenu]: _toggleMenuFlyout.MenuTypes.BeautyTipsMenu,
  [TopAreaNavigationLink.InspirationMenu]: _toggleMenuFlyout.MenuTypes.InspirationMenu
};
const TopAreaNavigationMenus = exports.TopAreaNavigationMenus = [_toggleMenuFlyout.MenuTypes.BeautyTipsMenu, _toggleMenuFlyout.MenuTypes.InspirationMenu];
